export class ValidationPluginError extends Error {}
